(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50330],{

/***/ 73405:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(49694);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36456);
/* harmony import */ var _redux_services_taxons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50173);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16502);








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var mapStateToProp = function(state) {
    return {
        taxons: state.taxons.items
    };
};
var HreflangLinks = function(param) {
    var locales = param.locales, taxons = param.taxons;
    var ref3;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var asPath = router.asPath, defaultLocale = router.defaultLocale, locale = router.locale;
    var category = router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.slug;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Map()), allTaxons = ref1[0], setAllTaxons = ref1[1];
    var uniqueLocales = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return Array.from(new Set(locales.map(function(loc) {
            return loc.split('-')[0];
        }))).map(function(uniqueLoc) {
            return locales.find(function(loc) {
                return loc.startsWith(uniqueLoc);
            });
        }).filter(function(loc) {
            return !!loc;
        });
    }, [
        locales
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), currentOrigin = ref2[0], setCurrentOrigin = ref2[1];
    var defaultLang = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return uniqueLocales.find(function(lang) {
            return lang.includes(defaultLocale);
        });
    }, [
        defaultLocale,
        uniqueLocales
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            setCurrentOrigin(window.location.origin);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref4;
        if (!router.isReady || taxons.length === 0 || locales.length === 1 || !category) return;
        setAllTaxons(new Map([
            [
                locale,
                ((ref4 = taxons[0]) === null || ref4 === void 0 ? void 0 : ref4.children) || []
            ]
        ]));
        var fetchTaxons = function() {
            var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(localesToFetch) {
                var ref, fetchedTaxons;
                return _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (0,_redux_services_taxons__WEBPACK_IMPORTED_MODULE_6__/* .getLocalesTaxons */ .OD)(localesToFetch);
                        case 3:
                            fetchedTaxons = _ctx.sent;
                            setAllTaxons(new Map(_toConsumableArray(Object.entries(fetchedTaxons)).concat([
                                [
                                    locale,
                                    ((ref = taxons[0]) === null || ref === void 0 ? void 0 : ref.children) || []
                                ], 
                            ])));
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchTaxons(localesToFetch) {
                return _ref.apply(this, arguments);
            };
        }();
        fetchTaxons(uniqueLocales.map(function(loc) {
            return loc.split('-')[0];
        }).filter(function(loc) {
            return loc !== locale;
        }));
    }, [
        locale,
        locales,
        taxons,
        router.isReady,
        uniqueLocales
    ]);
    var hreflangLinks = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var links = [];
        var slugs = category ? Array.isArray(category) ? _toConsumableArray(category) : [
            category
        ] : [];
        locales.forEach(function(loc) {
            var isDefault = loc === defaultLang;
            var currentLocale = loc.split('-')[0];
            if (isDefault) {
                var href = "".concat(currentOrigin).concat(asPath);
                if (currentLocale !== locale && (slugs === null || slugs === void 0 ? void 0 : slugs.length) > 0 && allTaxons.size > 1) {
                    href = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__/* .translateUrlSlugs */ .fg)(href, _toConsumableArray(slugs), allTaxons.get(locale), allTaxons.get(currentLocale));
                }
                links.push({
                    href: href.endsWith('/') ? href.slice(0, -1) : href,
                    hreflang: 'x-default'
                });
            }
            var href1 = "".concat(currentOrigin).concat(isDefault ? '' : "/".concat(currentLocale)).concat(asPath);
            if (currentLocale !== locale && (slugs === null || slugs === void 0 ? void 0 : slugs.length) > 0 && allTaxons.size > 1) {
                href1 = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__/* .translateUrlSlugs */ .fg)(href1, _toConsumableArray(slugs), allTaxons.get(locale), allTaxons.get(currentLocale));
            }
            links.push({
                href: href1.endsWith('/') ? href1.slice(0, -1) : href1,
                hreflang: loc
            });
        });
        return links;
    }, [
        locales,
        defaultLang,
        currentOrigin,
        asPath,
        locale,
        taxons,
        allTaxons
    ]);
    if (!currentOrigin || locales.length === 0 || !defaultLang) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
        children: hreflangLinks.map(function(link, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                rel: "alternate",
                href: link.href,
                hrefLang: link.hreflang
            }, index);
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProp)(HreflangLinks));


/***/ }),

/***/ 49694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js
var Accordion = __webpack_require__(36939);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(50743);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(61201);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./redux/actions/taxons.ts
var taxons = __webpack_require__(44279);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./components/Commitment/Commitment.tsx
var Commitment = __webpack_require__(88737);
// EXTERNAL MODULE: ./components/Hero/HeroSection.tsx
var HeroSection = __webpack_require__(87170);
// EXTERNAL MODULE: ./components/DateRangeForm/DateRangeForm.tsx + 1 modules
var DateRangeForm = __webpack_require__(4998);
// EXTERNAL MODULE: ./components/Shop/Catalog.tsx + 1 modules
var Catalog = __webpack_require__(54972);
// EXTERNAL MODULE: ./components/Shop/Shop.style.tsx
var Shop_style = __webpack_require__(45889);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js
var Drawer = __webpack_require__(39636);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./redux/actions/products.ts
var products = __webpack_require__(86730);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ExpandLess.js
var ExpandLess = __webpack_require__(31125);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ExpandMore.js
var esm_ExpandMore = __webpack_require__(73099);
;// CONCATENATED MODULE: ./components/Filters/AttributeListItem.tsx




var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        filterListItem: {
            cursor: 'pointer',
            height: 35,
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            justifyContent: 'space-between',
            fontSize: 14,
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight)
        }
    });
});
var AttributeListItem = function(param) {
    var handleToggle = param.handleToggle, checked = param.checked, index = param.index, code = param.code, attributeKey = param.attributeKey, name = param.name;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(classes.filterListItem),
            onClick: function() {
                return handleToggle(code, attributeKey, name);
            },
            style: {
                paddingLeft: '16px'
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        edge: "start",
                        checked: checked,
                        tabIndex: -1,
                        disableRipple: true
                    }),
                    name
                ]
            })
        }, index)
    }));
};
/* harmony default export */ var Filters_AttributeListItem = (AttributeListItem);

// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 2 modules
var TextField = __webpack_require__(4073);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slider/Slider.js + 1 modules
var Slider = __webpack_require__(59122);
;// CONCATENATED MODULE: ./typings/filters.ts
var PriceAttributeCode;
(function(PriceAttributeCode) {
    PriceAttributeCode["PRICE"] = 'price';
})(PriceAttributeCode || (PriceAttributeCode = {}));
var AttributeType;
(function(AttributeType) {
    AttributeType["SELECT"] = 'select';
    AttributeType["CHECKBOX"] = 'checkbox';
    AttributeType["PRICE"] = 'price';
    AttributeType["TAKE_BACK_PRICE"] = 'takeBackPrice';
})(AttributeType || (AttributeType = {}));

;// CONCATENATED MODULE: ./components/Filters/PricesFilter.tsx








var usePriceFilterStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var ref;
    return (0,createStyles/* default */.Z)({
        priceInputsContainer: {
            display: 'flex',
            gap: theme.spacing(2),
            marginTop: theme.spacing(2),
            alignItems: 'center'
        },
        priceInput: {
            flex: 1,
            '& .MuiOutlinedInput-root': {
                borderRadius: 4
            },
            '& .MuiOutlinedInput-input': {
                padding: theme.spacing(1.5),
                fontSize: 14
            }
        },
        priceSeparator: {
            color: ((ref = theme.extraColors) === null || ref === void 0 ? void 0 : ref.greyText) || '#666',
            fontSize: 14
        },
        sliderWrapper: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1)
        }
    });
});
var PricesFilter = function(param) {
    var attributeFilter = param.attributeFilter, handleExtend = param.handleExtend, t = param.t, prismicShopData = param.prismicShopData, open = param.open, priceRange = param.priceRange, rangeSelector = param.rangeSelector;
    var ref6, ref1;
    var attributeType = attributeFilter.type;
    var attributeCode = attributeFilter.code;
    var classes = AttributesFilters_useStyles();
    var priceClasses = usePriceFilterStyles();
    var ref2;
    // Use Prismic values if defined, otherwise fall back to attributeFilter values
    var minLimit = (ref2 = prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.filter_price_min) !== null && ref2 !== void 0 ? ref2 : attributeFilter.minimum / 100;
    var ref3;
    var maxLimit = (ref3 = prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.filter_price_max) !== null && ref3 !== void 0 ? ref3 : attributeFilter.maximum / 100;
    // Local state for text inputs to allow typing without immediate validation
    var ref4 = (0,react.useState)(''), minInputValue = ref4[0], setMinInputValue = ref4[1];
    var ref5 = (0,react.useState)(''), maxInputValue = ref5[0], setMaxInputValue = ref5[1];
    // Sync local state with priceRange when it changes (e.g., from slider)
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = priceRange[attributeType]) === null || ref === void 0 ? void 0 : ref.length) === 2) {
            setMinInputValue(String(priceRange[attributeType][0]));
            setMaxInputValue(String(priceRange[attributeType][1]));
        }
    }, [
        priceRange,
        attributeType
    ]);
    // Handle min price input change
    var handleMinInputChange = (0,react.useCallback)(function(event) {
        var value = event.target.value;
        // Allow empty or numeric values
        if (value === '' || /^\d*\.?\d*$/.test(value)) {
            setMinInputValue(value);
        }
    }, []);
    // Handle max price input change
    var handleMaxInputChange = (0,react.useCallback)(function(event) {
        var value = event.target.value;
        // Allow empty or numeric values
        if (value === '' || /^\d*\.?\d*$/.test(value)) {
            setMaxInputValue(value);
        }
    }, []);
    // Validate and apply min price on blur
    var handleMinInputBlur = (0,react.useCallback)(function() {
        var ref;
        var newMin = parseFloat(minInputValue) || minLimit;
        var ref7;
        var currentMax = (ref7 = (ref = priceRange[attributeType]) === null || ref === void 0 ? void 0 : ref[1]) !== null && ref7 !== void 0 ? ref7 : maxLimit;
        // Ensure min is within bounds
        newMin = Math.max(minLimit, Math.min(newMin, currentMax));
        setMinInputValue(String(newMin));
        // Trigger the rangeSelector with the new values
        var syntheticEvent = {};
        rangeSelector(attributeType)(syntheticEvent, [
            newMin,
            currentMax
        ]);
    }, [
        minInputValue,
        minLimit,
        maxLimit,
        priceRange,
        attributeType,
        rangeSelector, 
    ]);
    // Validate and apply max price on blur
    var handleMaxInputBlur = (0,react.useCallback)(function() {
        var ref;
        var newMax = parseFloat(maxInputValue) || maxLimit;
        var ref8;
        var currentMin = (ref8 = (ref = priceRange[attributeType]) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref8 !== void 0 ? ref8 : minLimit;
        // Ensure max is within bounds
        newMax = Math.max(currentMin, Math.min(newMax, maxLimit));
        setMaxInputValue(String(newMax));
        // Trigger the rangeSelector with the new values
        var syntheticEvent = {};
        rangeSelector(attributeType)(syntheticEvent, [
            currentMin,
            newMax
        ]);
    }, [
        maxInputValue,
        minLimit,
        maxLimit,
        priceRange,
        attributeType,
        rangeSelector, 
    ]);
    // Handle Enter key press to apply values
    var handleKeyPress = (0,react.useCallback)(function(event, isMin) {
        if (event.key === 'Enter') {
            if (isMin) {
                handleMinInputBlur();
            } else {
                handleMaxInputBlur();
            }
        }
    }, [
        handleMinInputBlur,
        handleMaxInputBlur
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                className: classes.filterListItem,
                onClick: function() {
                    return handleExtend(attributeFilter, AttributeType.PRICE);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body1',
                        component: 'p',
                        className: classes.attributeTitle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            defaultText: t('texts:shop:filter_price'),
                            data: prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.filter_price
                        })
                    }),
                    ((ref6 = open.find(function(opened) {
                        return opened.value === attributeCode;
                    })) === null || ref6 === void 0 ? void 0 : ref6.open) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExpandMore/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: (ref1 = open.find(function(opened) {
                    return opened.value === attributeCode;
                })) === null || ref1 === void 0 ? void 0 : ref1.open,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    component: "div",
                    disablePadding: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.sliderContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                id: "range-slider",
                                gutterBottom: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    defaultText: t('texts:shop:price_fork'),
                                    data: prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.price_fork
                                })
                            }),
                            (prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.display_price_range_inputs) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: priceClasses.priceInputsContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        className: priceClasses.priceInput,
                                        variant: "outlined",
                                        size: "small",
                                        type: "text",
                                        inputMode: "decimal",
                                        placeholder: String(minLimit),
                                        value: minInputValue,
                                        onChange: handleMinInputChange,
                                        onBlur: handleMinInputBlur,
                                        onKeyPress: function(e) {
                                            return handleKeyPress(e, true);
                                        },
                                        InputProps: {
                                            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                position: "start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: (prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.price_range_inputs_placeholder_min) || t('texts:shop:price_min_label')
                                                })
                                            }),
                                            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                position: "end",
                                                children: attributeFilter.currency
                                            })
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: priceClasses.priceSeparator,
                                        children: "—"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        className: priceClasses.priceInput,
                                        variant: "outlined",
                                        size: "small",
                                        type: "text",
                                        inputMode: "decimal",
                                        placeholder: String(maxLimit),
                                        value: maxInputValue,
                                        onChange: handleMaxInputChange,
                                        onBlur: handleMaxInputBlur,
                                        onKeyPress: function(e) {
                                            return handleKeyPress(e, false);
                                        },
                                        InputProps: {
                                            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                position: "start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: (prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.price_range_inputs_placeholder_max) || t('texts:shop:price_max_label')
                                                })
                                            }),
                                            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                position: "end",
                                                children: attributeFilter.currency
                                            })
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: priceClasses.sliderWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                                    value: priceRange[attributeType],
                                    onChange: rangeSelector(attributeType),
                                    min: minLimit,
                                    valueLabelDisplay: "auto",
                                    max: maxLimit
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                id: "range-slider",
                                gutterBottom: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        defaultText: t('texts:shop:between'),
                                        data: prismicShopData === null || prismicShopData === void 0 ? void 0 : prismicShopData.between,
                                        asText: true
                                    }),
                                    ' ',
                                    "".concat(priceRange[attributeType][0], " ").concat(t('texts:shop:and'), " ").concat(priceRange[attributeType][1], " ").concat(attributeFilter.currency)
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }, attributeType));
};
/* harmony default export */ var Filters_PricesFilter = (PricesFilter);

;// CONCATENATED MODULE: ./components/Filters/SelectFilter.tsx






var RenderSelectFilter = function(param) {
    var attributeFilter = param.attributeFilter, handleExtend = param.handleExtend, open = param.open, selectedAttributes = param.selectedAttributes, handleToggle = param.handleToggle;
    var ref4, ref1, ref2;
    var classes = AttributesFilters_useStyles();
    var attributeType = attributeFilter === null || attributeFilter === void 0 ? void 0 : attributeFilter.type;
    var attributeCode = attributeFilter === null || attributeFilter === void 0 ? void 0 : attributeFilter.code;
    var sortArrayAlphanumeric = function(arr) {
        return arr.sort(function(a, b) {
            return a.value.localeCompare(b.value, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                className: classes.filterListItem,
                onClick: function() {
                    return handleExtend(attributeFilter);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body1',
                        component: 'div',
                        className: classes.attributeTitle,
                        children: attributeFilter.name
                    }),
                    ((ref4 = open.find(function(opened) {
                        return opened.value === attributeCode;
                    })) === null || ref4 === void 0 ? void 0 : ref4.open) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExpandMore/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: (ref1 = open.find(function(opened) {
                    return opened.value === attributeCode;
                })) === null || ref1 === void 0 ? void 0 : ref1.open,
                timeout: "auto",
                unmountOnExit: true,
                className: classes.filterListContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    component: "div",
                    disablePadding: true,
                    children: (ref2 = sortArrayAlphanumeric(attributeFilter.choices)) === null || ref2 === void 0 ? void 0 : ref2.map(function(choice, index) {
                        var ref, ref3;
                        var currentAttributeCat = (ref = selectedAttributes === null || selectedAttributes === void 0 ? void 0 : selectedAttributes.find(function(selected) {
                            return selected.code === attributeFilter.code;
                        })) === null || ref === void 0 ? void 0 : (ref3 = ref.values) === null || ref3 === void 0 ? void 0 : ref3.find(function(value) {
                            return value === choice.key;
                        });
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_AttributeListItem, {
                                code: attributeFilter.code,
                                attributeKey: choice.key,
                                handleToggle: handleToggle,
                                index: index,
                                name: choice.value,
                                checked: typeof currentAttributeCat !== 'undefined'
                            })
                        }, index));
                    })
                })
            })
        ]
    }, attributeType));
};
/* harmony default export */ var SelectFilter = (RenderSelectFilter);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Search.js
var Search = __webpack_require__(17215);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Close.js
var Close = __webpack_require__(59544);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./components/Filters/AutocompleteFilter.tsx










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var AutocompleteFilter_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        container: {
            position: 'relative',
            width: '100%'
        },
        input: {
            width: '100%',
            '& .MuiInputBase-root': {
                borderRadius: 4
            }
        },
        dropdown: {
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1000,
            maxHeight: 210,
            overflowY: 'auto',
            backgroundColor: theme.palette.common.white,
            border: "1px solid ".concat(theme.palette.divider),
            borderRadius: 4,
            boxShadow: theme.shadows[2]
        },
        listItem: {
            padding: theme.spacing(0.5, 2),
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        },
        selectedValues: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(0.5),
            marginTop: theme.spacing(1)
        },
        chip: {
            margin: theme.spacing(0.25)
        },
        noResults: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary
        }
    });
});
var mapDispatchToProps = {
    getAttributeValues: taxons/* getAttributeValues */.dH
};
var AutocompleteFilter = function(param) {
    var attributeCode = param.attributeCode, attributeName = param.attributeName, selectedValues = param.selectedValues, onValuesChange = param.onValuesChange, _attributeValues = param.attributeValues, attributeValues = _attributeValues === void 0 ? [] : _attributeValues, _loading = param.loading, loading = _loading === void 0 ? false : _loading, getAttributeValues1 = param.getAttributeValues;
    var classes = AutocompleteFilter_useStyles();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var locale = router.locale || 'fr';
    var ref = (0,react.useState)(''), searchQuery = ref[0], setSearchQuery = ref[1];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(null), inputRef = ref2[0], setInputRef = ref2[1];
    var ref3 = (0,react.useState)(10), displayedCount = ref3[0], setDisplayedCount = ref3[1];
    var ref4 = (0,react.useState)(false), isLoadingMore = ref4[0], setIsLoadingMore = ref4[1];
    // Fetch attribute values when component mounts or locale changes
    (0,react.useEffect)(function() {
        if (constants/* enableSearchFilterValuesFor.includes */.yD.includes(attributeCode)) {
            getAttributeValues1(attributeCode);
        }
    }, [
        attributeCode,
        getAttributeValues1,
        locale
    ]);
    // Clear search when locale changes
    (0,react.useEffect)(function() {
        setSearchQuery('');
        setDisplayedCount(10);
    }, [
        locale
    ]);
    // Reset displayed count when search changes
    (0,react.useEffect)(function() {
        setDisplayedCount(10);
    }, [
        searchQuery
    ]);
    // Filter values based on search query
    var filteredValues = (0,react.useMemo)(function() {
        var filtered = attributeValues;
        if (searchQuery.trim()) {
            filtered = attributeValues.filter(function(value) {
                return value.value.toLowerCase().includes(searchQuery.toLowerCase());
            });
        }
        return filtered.slice(0, displayedCount);
    }, [
        attributeValues,
        searchQuery,
        displayedCount
    ]);
    // Check if there are more values to load
    var hasMoreValues = (0,react.useMemo)(function() {
        var filtered = attributeValues;
        if (searchQuery.trim()) {
            filtered = attributeValues.filter(function(value) {
                return value.value.toLowerCase().includes(searchQuery.toLowerCase());
            });
        }
        return filtered.length > displayedCount;
    }, [
        attributeValues,
        searchQuery,
        displayedCount
    ]);
    var handleInputChange = function(event) {
        setSearchQuery(event.target.value);
        setDisplayedCount(10) // Reset to first 10 when searching
        ;
        setIsOpen(true);
    };
    var handleLoadMore = function(event) {
        event.preventDefault();
        event.stopPropagation();
        setIsLoadingMore(true);
        // Simulate loading delay
        setTimeout(function() {
            setDisplayedCount(function(prev) {
                return prev + 10;
            });
            setIsLoadingMore(false);
        }, 300);
    };
    var handleValueToggle = function(valueKey, event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        var newValues = selectedValues.includes(valueKey) ? selectedValues.filter(function(key) {
            return key !== valueKey;
        }) : _toConsumableArray(selectedValues).concat([
            valueKey
        ]);
        onValuesChange(newValues);
    };
    var handleRemoveValue = function(valueKey) {
        var newValues = selectedValues.filter(function(key) {
            return key !== valueKey;
        });
        onValuesChange(newValues);
    };
    var handleInputFocus = function() {
        setIsOpen(true);
    };
    var handleInputBlur = function(event) {
        // Delay closing to allow clicking on dropdown items
        setTimeout(function() {
            if (!(inputRef === null || inputRef === void 0 ? void 0 : inputRef.contains(event.relatedTarget))) {
                setIsOpen(false);
            }
        }, 150);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                ref: setInputRef,
                className: classes.input,
                placeholder: t('texts:shop:autocomplete_search_placeholder', {
                    attributeName: attributeName
                }),
                value: searchQuery,
                onChange: handleInputChange,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                        color: "action"
                    })
                },
                disabled: loading
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                className: classes.dropdown,
                children: [
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.noResults,
                        children: t('texts:shop:autocomplete_loading')
                    }) : filteredValues.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        dense: true,
                        children: filteredValues.map(function(value) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                className: classes.listItem,
                                onClick: function(e) {
                                    return handleValueToggle(value.key, e);
                                },
                                onMouseDown: function(e) {
                                    return e.preventDefault();
                                },
                                button: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            checked: selectedValues.includes(value.key),
                                            edge: "start",
                                            disableRipple: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                        primary: value.value
                                    })
                                ]
                            }, value.key);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.noResults,
                        children: searchQuery ? t('texts:shop:autocomplete_no_results') : t('texts:shop:autocomplete_no_values')
                    }),
                    hasMoreValues && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: '8px',
                            textAlign: 'center',
                            borderTop: '1px solid #e0e0e0'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleLoadMore,
                            onMouseDown: function(e) {
                                return e.preventDefault();
                            },
                            disabled: isLoadingMore,
                            style: {
                                background: 'none',
                                border: 'none',
                                color: '#1976d2',
                                cursor: 'pointer',
                                padding: '8px 16px',
                                fontSize: '14px'
                            },
                            children: isLoadingMore ? t('texts:shop:autocomplete_loading') : t('texts:shop:autocomplete_load_more')
                        })
                    })
                ]
            }),
            selectedValues.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.selectedValues,
                children: selectedValues.map(function(key) {
                    var value = attributeValues.find(function(v) {
                        return v.key === key;
                    });
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        label: (value === null || value === void 0 ? void 0 : value.value) || key,
                        onDelete: function() {
                            return handleRemoveValue(key);
                        },
                        className: classes.chip,
                        size: "small",
                        deleteIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    }, key));
                })
            })
        ]
    }));
};
/* harmony default export */ var Filters_AutocompleteFilter = ((0,es/* connect */.$j)(null, mapDispatchToProps)(AutocompleteFilter));

;// CONCATENATED MODULE: ./components/Filters/AttributesFilters.tsx
/* provided dependency */ var process = __webpack_require__(34155);















function AttributesFilters_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AttributesFilters_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AttributesFilters_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AttributesFilters_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AttributesFilters_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AttributesFilters_toConsumableArray(arr) {
    return AttributesFilters_arrayWithoutHoles(arr) || AttributesFilters_iterableToArray(arr) || AttributesFilters_unsupportedIterableToArray(arr) || AttributesFilters_nonIterableSpread();
}
function AttributesFilters_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AttributesFilters_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AttributesFilters_arrayLikeToArray(o, minLen);
}
var AttributesFilters_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        filterListItem: {
            cursor: 'pointer',
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            justifyContent: 'space-between',
            fontSize: 14,
            height: 35,
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight)
        },
        filterListContent: {
            backgroundColor: theme.palette.common.white,
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight)
        },
        attribute_list: {
            padding: theme.spacing(0, 0, 8, 0)
        },
        sliderContainer: {
            width: '100%',
            padding: theme.spacing(2, 3)
        },
        checkBoxValue: {
            paddingLeft: theme.spacing(2),
            textTransform: 'none'
        },
        attributeTitle: {
            fontSize: 14,
            lineHeight: 1
        }
    });
});
var mapStateToProps = function(state) {
    return {
        attributeValues: state.taxons.attributeValues
    };
};
var AttributesFilters_mapDispatchToProps = {};
var AttributesFilters = function(param) {
    var attributes = param.attributes, setSelectedAttributes = param.setSelectedAttributes, takebackText = param.takebackText, selectedAttributes = param.selectedAttributes, doc = param.doc, t = param.t, parameters = param.parameters, isSecondHandTaxons = param.isSecondHandTaxons, attributeValues = param.attributeValues;
    var ref6, ref1;
    var classes = AttributesFilters_useStyles();
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var ref2 = (0,react.useState)([]), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,react.useState)({
        price: [],
        takeBackPrice: []
    }), priceRange = ref3[0], setPriceRange = ref3[1];
    var ref4 = (0,react.useState)(false), qualitiesList = ref4[0], setQualitiesList = ref4[1];
    var noPriceFilter = process.env.NO_PRICE_FILTER == 'false' || !process.env.NO_PRICE_FILTER;
    var ref5 = (0,react.useMemo)(function() {
        return {
            takeBackPriceAttributeInformations: attributes.find(function(attr) {
                return attr.type === AttributeType.TAKE_BACK_PRICE;
            }),
            priceAttributeInformations: attributes.find(function(attr) {
                return attr.type === AttributeType.PRICE;
            }),
            selectAttributeInformations: attributes.filter(function(attr) {
                return attr.type === AttributeType.SELECT;
            })
        };
    }, [
        attributes
    ]), takeBackPriceAttributeInformations = ref5.takeBackPriceAttributeInformations, priceAttributeInformations = ref5.priceAttributeInformations, selectAttributeInformations = ref5.selectAttributeInformations;
    (0,react.useEffect)(function() {
        if ((selectedAttributes === null || selectedAttributes === void 0 ? void 0 : selectedAttributes.length) > 0) {
            var ref9;
            var tempOpen = [];
            var isQualities = ((ref9 = selectedAttributes.find(function(el) {
                return el.code === 'productCondition';
            })) === null || ref9 === void 0 ? void 0 : ref9.length) > 0;
            attributes.map(function(attribute) {
                var ref;
                var attributeFound = selectedAttributes.find(function(selectedAttribute) {
                    return selectedAttribute.code === attribute.type;
                });
                if ((attributeFound === null || attributeFound === void 0 ? void 0 : (ref = attributeFound.values) === null || ref === void 0 ? void 0 : ref.length) > 0 && attribute.code !== 'productCondition') {
                    tempOpen.push({
                        value: attribute.code,
                        open: true
                    });
                }
                if (attributeFound && attribute.code === PriceAttributeCode.PRICE) {
                    var ref7, ref8;
                    // need to cast attribute as PriceAttribute to access minimum and maximum
                    var priceAttribute = attribute;
                    // Use Prismic values if defined, otherwise fall back to attributeFilter values
                    var prismicMin = doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.filter_price_min;
                    var prismicMax = doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.filter_price_max;
                    var attrMinInEuros = prismicMin !== null && prismicMin !== void 0 ? prismicMin : priceAttribute.minimum / 100;
                    var attrMaxInEuros = prismicMax !== null && prismicMax !== void 0 ? prismicMax : priceAttribute.maximum / 100;
                    var minInCents = attrMinInEuros * 100;
                    var maxInCents = attrMaxInEuros * 100;
                    var minimum = attributeFound.values.min < minInCents || attributeFound.values.min > maxInCents ? minInCents : attributeFound.values.min;
                    var maximum = attributeFound.values.max > maxInCents || attributeFound.values.max < minInCents ? maxInCents : attributeFound.values.max;
                    // setPriceRange([minimum / 100, maximum / 100])
                    setPriceRange(function(prev) {
                        return _objectSpread({}, prev, _defineProperty({}, attribute.type, [
                            minimum / 100,
                            maximum / 100
                        ]));
                    });
                    tempOpen.push({
                        value: attribute.code,
                        open: true
                    });
                }
            });
            isQualities && setQualitiesList(true);
            setOpen(tempOpen);
        }
    }, []);
    // extand the attribute list
    var handleExtend = function(attributeFilter, type) {
        if (type === AttributeType.PRICE) {
            var ref, ref11;
            // Use Prismic values if defined, otherwise fall back to attributeFilter values
            var prismicMin = doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.filter_price_min;
            var prismicMax = doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.filter_price_max;
            var minLimit = prismicMin !== null && prismicMin !== void 0 ? prismicMin : attributeFilter.minimum / 100;
            var maxLimit = prismicMax !== null && prismicMax !== void 0 ? prismicMax : attributeFilter.maximum / 100;
            if (priceRange.price.length === 0 && attributeFilter.type === AttributeType.PRICE) {
                setPriceRange(function(prev) {
                    return _objectSpread({}, prev, _defineProperty({}, attributeFilter.type, [
                        minLimit,
                        maxLimit
                    ]));
                });
            }
            if (priceRange.takeBackPrice.length === 0 && attributeFilter.type === AttributeType.TAKE_BACK_PRICE) {
                setPriceRange(function(prev) {
                    return _objectSpread({}, prev, _defineProperty({}, attributeFilter.type, [
                        minLimit,
                        maxLimit
                    ]));
                });
            }
        }
        var tempOpen = AttributesFilters_toConsumableArray(open);
        if (tempOpen.find(function(isopened) {
            return isopened.value === (attributeFilter === null || attributeFilter === void 0 ? void 0 : attributeFilter.code);
        })) {
            tempOpen.splice(tempOpen.findIndex(function(isopened) {
                return isopened.value === (attributeFilter === null || attributeFilter === void 0 ? void 0 : attributeFilter.code);
            }), 1);
        } else {
            tempOpen.push({
                value: attributeFilter === null || attributeFilter === void 0 ? void 0 : attributeFilter.code,
                open: true
            });
        }
        setOpen(tempOpen);
    };
    // select an attribute in the list
    var handleToggle = function(code, key) {
        var tempSelectedAttributes = AttributesFilters_toConsumableArray(selectedAttributes);
        var isCodeSelected = tempSelectedAttributes === null || tempSelectedAttributes === void 0 ? void 0 : tempSelectedAttributes.find(function(isSelected) {
            return isSelected.code === code;
        });
        if (isCodeSelected) {
            var ref;
            var selectedCategorieIndex = isCodeSelected === null || isCodeSelected === void 0 ? void 0 : (ref = isCodeSelected.values) === null || ref === void 0 ? void 0 : ref.findIndex(function(value) {
                return value === key;
            });
            if (selectedCategorieIndex >= 0) {
                tempSelectedAttributes.find(function(isSelected) {
                    return isSelected.code === code;
                }).values.splice(selectedCategorieIndex, 1);
            } else {
                var ref12;
                (ref12 = tempSelectedAttributes === null || tempSelectedAttributes === void 0 ? void 0 : tempSelectedAttributes.find(function(isSelected) {
                    return isSelected.code === code;
                }).values) === null || ref12 === void 0 ? void 0 : ref12.push(key);
            }
        } else {
            tempSelectedAttributes.push({
                code: code,
                values: [
                    key
                ]
            });
        }
        setSelectedAttributes(tempSelectedAttributes);
    };
    // set true false for checkbox attributes
    var handleToggleCheckbox = function(code) {
        var tempSelectedAttributes = AttributesFilters_toConsumableArray(selectedAttributes);
        var isCodeSelected = tempSelectedAttributes === null || tempSelectedAttributes === void 0 ? void 0 : tempSelectedAttributes.find(function(isSelected) {
            return isSelected.code === code;
        });
        if (isCodeSelected) {
            var currentValueIndex = tempSelectedAttributes === null || tempSelectedAttributes === void 0 ? void 0 : tempSelectedAttributes.findIndex(function(isSelected) {
                return isSelected.code === code;
            });
            tempSelectedAttributes[currentValueIndex].value = !tempSelectedAttributes[currentValueIndex].value;
        } else {
            tempSelectedAttributes.push({
                code: code,
                value: true
            });
        }
        setSelectedAttributes(tempSelectedAttributes);
    };
    // set priceRange
    var rangeSelector = function(attributeType) {
        return function(event, newValue) {
            setPriceRange(function(prev) {
                return _objectSpread({}, prev, _defineProperty({}, attributeType, newValue));
            });
            var tempSelectedAttributes = AttributesFilters_toConsumableArray(selectedAttributes);
            var isCodeSelected = tempSelectedAttributes === null || tempSelectedAttributes === void 0 ? void 0 : tempSelectedAttributes.find(function(isSelected) {
                return isSelected.code === attributeType;
            });
            if (typeof isCodeSelected !== 'undefined') {
                var selectedCategorieIndex = tempSelectedAttributes.findIndex(function(isSelected) {
                    return isSelected.code === attributeType;
                });
                tempSelectedAttributes[selectedCategorieIndex].values = {
                    min: newValue[0] * 100,
                    max: newValue[1] * 100
                };
            } else {
                tempSelectedAttributes.push({
                    code: attributeType,
                    values: {
                        min: newValue[0] * 100,
                        max: newValue[1] * 100
                    }
                });
            }
            setSelectedAttributes(tempSelectedAttributes);
        };
    };
    var handleExtendQualities = function() {
        setQualitiesList(!qualitiesList);
    };
    // Handle autocomplete filter value changes
    var handleAutocompleteChange = function(attributeCode, values) {
        var tempSelectedAttributes = AttributesFilters_toConsumableArray(selectedAttributes);
        var existingAttribute = tempSelectedAttributes.find(function(attr) {
            return attr.code === attributeCode;
        });
        if (existingAttribute) {
            existingAttribute.values = values;
        } else {
            tempSelectedAttributes.push({
                code: attributeCode,
                values: values
            });
        }
        setSelectedAttributes(tempSelectedAttributes);
    };
    // Determine which price attribute to use based on taxon type
    var selectedPriceAttribute = isSecondHandTaxons ? takeBackPriceAttributeInformations : priceAttributeInformations;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
        className: classes.attribute_list,
        children: [
            selectAttributeInformations !== undefined && selectAttributeInformations.length > 0 && selectAttributeInformations.map(function(attributeFilter, attributeIndex) {
                // Check if this attribute should use autocomplete
                if (constants/* enableSearchFilterValuesFor.includes */.yD.includes(attributeFilter.code.toUpperCase())) {
                    var ref, ref13;
                    var selectedValues = ((ref = selectedAttributes.find(function(attr) {
                        return attr.code === attributeFilter.code;
                    })) === null || ref === void 0 ? void 0 : ref.values) || [];
                    var attributeValuesData = attributeValues === null || attributeValues === void 0 ? void 0 : attributeValues[attributeFilter.code];
                    var isOpen = (ref13 = open.find(function(opened) {
                        return opened.value === attributeFilter.code;
                    })) === null || ref13 === void 0 ? void 0 : ref13.open;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                className: classes.filterListItem,
                                onClick: function() {
                                    return handleExtend(attributeFilter, attributeFilter.type);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body1',
                                        component: 'div',
                                        className: classes.attributeTitle,
                                        children: attributeFilter.name
                                    }),
                                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExpandMore/* default */.Z, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                in: isOpen,
                                timeout: "auto",
                                unmountOnExit: true,
                                className: classes.filterListContent,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        padding: '16px'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_AutocompleteFilter, {
                                        attributeCode: attributeFilter.code,
                                        attributeName: attributeFilter.name,
                                        selectedValues: selectedValues,
                                        onValuesChange: function(values) {
                                            return handleAutocompleteChange(attributeFilter.code, values);
                                        },
                                        attributeValues: (attributeValuesData === null || attributeValuesData === void 0 ? void 0 : attributeValuesData.values) || (attributeFilter === null || attributeFilter === void 0 ? void 0 : attributeFilter.choices) || [],
                                        loading: (attributeValuesData === null || attributeValuesData === void 0 ? void 0 : attributeValuesData.loading) || false
                                    })
                                })
                            })
                        ]
                    }, attributeFilter.code));
                }
                // Use regular select filter for other attributes
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SelectFilter, {
                    attributeFilter: attributeFilter,
                    handleExtend: handleExtend,
                    open: open,
                    selectedAttributes: selectedAttributes,
                    handleToggle: handleToggle
                }, attributeIndex));
            }),
            selectedPriceAttribute !== undefined && noPriceFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_PricesFilter, {
                attributeFilter: selectedPriceAttribute,
                handleExtend: handleExtend,
                t: t,
                prismicShopData: doc === null || doc === void 0 ? void 0 : doc.data,
                open: open,
                priceRange: priceRange,
                rangeSelector: rangeSelector
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: attributes.map(function(attributeFilter, attributeIndex) {
                    if (attributeFilter.type === AttributeType.CHECKBOX) {
                        var ref;
                        var value = (ref = selectedAttributes.find(function(attribute) {
                            return attribute.code === attributeFilter.code;
                        })) === null || ref === void 0 ? void 0 : ref.value;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.filterListItem, classes.checkBoxValue),
                            onClick: function() {
                                return handleToggleCheckbox(attributeFilter.code);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    edge: "start",
                                    checked: !!value,
                                    tabIndex: -1,
                                    disableRipple: true
                                }),
                                attributeFilter.code
                            ]
                        }, attributeIndex));
                    }
                })
            }),
            !constants/* disableQualityFilter */.Hw && (parameters === null || parameters === void 0 ? void 0 : (ref6 = parameters.items) === null || ref6 === void 0 ? void 0 : ref6.enableTakeBack) && isSecondHandTaxons && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                        className: classes.filterListItem,
                        onClick: handleExtendQualities,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body1',
                                component: 'div',
                                className: (0,clsx_m/* default */.Z)(classes.attributeTitle, 'filter__states__title'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    defaultText: t('texts:shop:states'),
                                    data: doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.states
                                })
                            }),
                            qualitiesList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExpandMore/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                        in: qualitiesList,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            component: "div",
                            disablePadding: true,
                            children: [
                                'perfectCondition',
                                'veryGoodCondition',
                                'goodCondition'
                            ].filter(function(choice) {
                                var ref;
                                return !(choice === 'goodCondition' && (takebackText === null || takebackText === void 0 ? void 0 : (ref = takebackText.data) === null || ref === void 0 ? void 0 : ref.disable_good_condition));
                            }).map(function(choice, index) {
                                var ref, ref14, ref15;
                                var currentAttributeCat = (ref = selectedAttributes === null || selectedAttributes === void 0 ? void 0 : selectedAttributes.find(function(selected) {
                                    return selected.code === 'productCondition';
                                })) === null || ref === void 0 ? void 0 : (ref14 = ref.values) === null || ref14 === void 0 ? void 0 : ref14.find(function(value) {
                                    return value === choice;
                                });
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_AttributeListItem, {
                                        code: 'productCondition',
                                        attributeKey: choice,
                                        handleToggle: handleToggle,
                                        index: index,
                                        name: productCheckState(takebackText === null || takebackText === void 0 ? void 0 : takebackText.data)[(ref15 = Object.keys(productCheckState(takebackText))) === null || ref15 === void 0 ? void 0 : ref15.find(function(key) {
                                            return key === choice;
                                        })].title,
                                        checked: typeof currentAttributeCat !== 'undefined'
                                    })
                                }, index));
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Filters_AttributesFilters = ((0,es/* connect */.$j)(mapStateToProps, AttributesFilters_mapDispatchToProps)(AttributesFilters));

// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField_TextField = __webpack_require__(59000);
;// CONCATENATED MODULE: ./components/Filters/SizesFilters.tsx









function SizesFilters_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SizesFilters_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SizesFilters_arrayLikeToArray(arr);
}
function SizesFilters_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SizesFilters_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SizesFilters_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SizesFilters_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SizesFilters_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SizesFilters_toConsumableArray(arr) {
    return SizesFilters_arrayWithoutHoles(arr) || SizesFilters_iterableToArray(arr) || SizesFilters_unsupportedIterableToArray(arr) || SizesFilters_nonIterableSpread();
}
function SizesFilters_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SizesFilters_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SizesFilters_arrayLikeToArray(o, minLen);
}
var SizesFilters_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        filterListItem: {
            cursor: 'pointer',
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            justifyContent: 'space-between',
            fontSize: 14,
            height: 35,
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
            '&:active': {
                backgroundColor: theme.extraColors.greyLight
            }
        },
        attribute_list: {
            padding: 0
        },
        sliderContainer: {
            width: '100%',
            padding: theme.spacing(2)
        },
        checkBoxValue: {
            paddingLeft: theme.spacing(2),
            textTransform: 'none'
        },
        attributeTitle: {
            fontSize: 14,
            lineHeight: '10px'
        },
        sizeFilterInput: {
            display: 'none'
        }
    });
});
var SizesFilters = function(param) {
    var sizes = param.sizes, setSelectedAttributes = param.setSelectedAttributes, selectedAttributes = param.selectedAttributes;
    var classes = SizesFilters_useStyles();
    var ref2 = (0,react.useState)([]), open = ref2[0], setOpen = ref2[1];
    var ref1 = (0,react.useState)(''), filterText = ref1[0], setFilterText = ref1[1];
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    (0,react.useEffect)(function() {
        if ((selectedAttributes === null || selectedAttributes === void 0 ? void 0 : selectedAttributes.length) > 0) {
            var tempOpen = [];
            sizes.map(function(size, index) {
                var ref;
                var selectedValues = (ref = selectedAttributes.find(function(selectedAttribute) {
                    return selectedAttribute.code === 'size';
                })) === null || ref === void 0 ? void 0 : ref.values;
                selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(function(value) {
                    if (size.sizes.find(function(listItem) {
                        return listItem.code === value;
                    })) {
                        tempOpen.push({
                            value: index,
                            open: true
                        });
                    }
                });
            });
            setOpen(tempOpen);
        }
    }, []);
    // extand the attribute list
    var handleExtend = function(attributeIndex) {
        var tempOpen = SizesFilters_toConsumableArray(open);
        if (tempOpen.find(function(isopened) {
            return isopened.value === attributeIndex;
        })) {
            tempOpen.splice(tempOpen.findIndex(function(isopened) {
                return isopened.value === attributeIndex;
            }), 1);
        } else {
            tempOpen.push({
                value: attributeIndex,
                open: true
            });
        }
        setOpen(tempOpen);
    };
    // select an attribute in the list
    var handleToggle = function(code, key) {
        var tempSelectedAttributes = SizesFilters_toConsumableArray(selectedAttributes);
        var isCodeSelected = tempSelectedAttributes === null || tempSelectedAttributes === void 0 ? void 0 : tempSelectedAttributes.find(function(isSelected) {
            return isSelected.code === code;
        });
        if (isCodeSelected) {
            var ref;
            var selectedCategorieIndex = isCodeSelected === null || isCodeSelected === void 0 ? void 0 : (ref = isCodeSelected.values) === null || ref === void 0 ? void 0 : ref.findIndex(function(value) {
                return value === key;
            });
            if (selectedCategorieIndex >= 0) {
                tempSelectedAttributes.find(function(isSelected) {
                    return isSelected.code === code;
                }).values.splice(selectedCategorieIndex, 1);
            } else {
                var ref3;
                (ref3 = tempSelectedAttributes === null || tempSelectedAttributes === void 0 ? void 0 : tempSelectedAttributes.find(function(isSelected) {
                    return isSelected.code === code;
                }).values) === null || ref3 === void 0 ? void 0 : ref3.push(key);
            }
        } else {
            tempSelectedAttributes.push({
                code: code,
                values: [
                    key
                ]
            });
        }
        trackEvent({
            category: 'Shop',
            action: "User select size ".concat(key)
        });
        setSelectedAttributes(tempSelectedAttributes);
    };
    var filteredSizesList = react.useMemo(function() {
        return sizes.map(function(sizeFilter) {
            var ref;
            return SizesFilters_objectSpread({}, sizeFilter, {
                filteredSizes: (ref = sizeFilter.sizes) === null || ref === void 0 ? void 0 : ref.filter(function(choice) {
                    return choice.name.toLowerCase().includes(filterText.toLowerCase());
                })
            });
        });
    }, [
        sizes,
        filterText
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        className: classes.attribute_list,
        children: filteredSizesList.map(function(sizeFilter, sizeIndex) {
            var ref7, ref4, ref5;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                        className: classes.filterListItem,
                        onClick: function() {
                            return handleExtend(sizeIndex);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body1',
                                component: 'div',
                                className: classes.attributeTitle,
                                children: sizeFilter.name
                            }),
                            ((ref7 = open.find(function(opened) {
                                return opened.value === sizeIndex;
                            })) === null || ref7 === void 0 ? void 0 : ref7.open) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExpandMore/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse/* default */.Z, {
                        in: (ref4 = open.find(function(opened) {
                            return opened.value === sizeIndex;
                        })) === null || ref4 === void 0 ? void 0 : ref4.open,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)('size-filter-input', classes.sizeFilterInput),
                                type: "text",
                                name: "size-filter-input",
                                value: filterText,
                                onChange: setFilterText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                component: "div",
                                disablePadding: true,
                                children: (ref5 = sizeFilter.filteredSizes) === null || ref5 === void 0 ? void 0 : ref5.map(function(choice, index) {
                                    var ref, ref6;
                                    var currentAttributeCat = (ref = selectedAttributes === null || selectedAttributes === void 0 ? void 0 : selectedAttributes.find(function(selected) {
                                        return selected.code === 'size';
                                    })) === null || ref === void 0 ? void 0 : (ref6 = ref.values) === null || ref6 === void 0 ? void 0 : ref6.find(function(value) {
                                        return value === choice.code;
                                    });
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_AttributeListItem, {
                                            code: 'size',
                                            attributeKey: choice.code,
                                            handleToggle: handleToggle,
                                            index: index,
                                            name: choice.name,
                                            checked: typeof currentAttributeCat !== 'undefined'
                                        })
                                    }, index));
                                })
                            })
                        ]
                    })
                ]
            }, sizeIndex));
        })
    }));
};
/* harmony default export */ var Filters_SizesFilters = (SizesFilters);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Replay.js
var Replay = __webpack_require__(43724);
// EXTERNAL MODULE: ./components/Filters/FilterDrawer.styles.ts
var FilterDrawer_styles = __webpack_require__(64060);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
;// CONCATENATED MODULE: ./components/Filters/TaxonListItem.tsx





var TaxonListItem_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        filterListItem: {
            cursor: 'pointer',
            height: 35,
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            justifyContent: 'space-between',
            fontSize: 14,
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight)
        },
        filterListItemActive: {
            //pointerEvents: 'none',
            color: theme.palette.primary.main,
            fontWeight: 700
        },
        checkBox: {
            lineHeight: '40px'
        },
        active: {
            fontWeight: 700
        }
    });
});
var TaxonListItem = function(param) {
    var taxon = param.taxon, handleToggle = param.handleToggle, checked = param.checked, index = param.index, position = param.position, name = param.name, isList = param.isList, hasCheckbox = param.hasCheckbox, open = param.open;
    var ref2, ref1;
    var classes = TaxonListItem_useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(classes.filterListItem, checked === index && classes.filterListItemActive),
            onClick: function() {
                var ref;
                return (taxon === null || taxon === void 0 ? void 0 : (ref = taxon.children) === null || ref === void 0 ? void 0 : ref.length) > 0 ? handleToggle(index, taxon, position) : checked !== index && handleToggle(index, taxon, position);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.checkBox, checked === index && (classes.active, 'filter__list_item--active')),
                    children: [
                        hasCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            edge: "start",
                            checked: isList ? checked : checked === index,
                            tabIndex: -1,
                            disableRipple: true
                        }),
                        name
                    ]
                }),
                (taxon === null || taxon === void 0 ? void 0 : (ref2 = taxon.children) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && hasCheckbox && (open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExpandMore/* default */.Z, {})),
                !hasCheckbox && (taxon === null || taxon === void 0 ? void 0 : (ref1 = taxon.children) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
            ]
        }, index)
    }));
};
/* harmony default export */ var Filters_TaxonListItem = (TaxonListItem);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(37661);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(32340);
// EXTERNAL MODULE: ./hooks/useShopSorting.ts
var useShopSorting = __webpack_require__(93795);
;// CONCATENATED MODULE: ./components/Filters/FilterDrawerSort.tsx





var FilterDrawerSort = function(param) {
    var doc = param.doc, sort = param.sort, onSortChange = param.onSortChange, t = param.t, classes = param.classes;
    var ref;
    var ref1 = (0,useShopSorting/* useShopSorting */.P)(doc, t), defaultSortValue = ref1.defaultSortValue, enableSorting = ref1.enableSorting, sortingOptions = ref1.sortingOptions, sortToString = ref1.sortToString, stringToSort = ref1.stringToSort;
    if (!enableSorting || sortingOptions.length === 0) {
        return null;
    }
    var sortingValue = sortToString(sort || defaultSortValue);
    var handleChange = function(_event, value) {
        onSortChange(stringToSort(value));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.sortSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "p",
                variant: "body1",
                color: "primary",
                className: classes.sortTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.sort_title,
                    defaultText: t('texts:shop:sort')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                value: sortingValue,
                onChange: handleChange,
                children: sortingOptions.map(function(option) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        value: option.value,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                            color: "primary"
                        }),
                        label: option.label
                    }, option.value);
                })
            })
        ]
    }));
};
/* harmony default export */ var Filters_FilterDrawerSort = (FilterDrawerSort);

;// CONCATENATED MODULE: ./components/Filters/FilterDrawer.tsx






















function FilterDrawer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FilterDrawer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return FilterDrawer_arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FilterDrawer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function FilterDrawer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FilterDrawer_toConsumableArray(arr) {
    return FilterDrawer_arrayWithoutHoles(arr) || FilterDrawer_iterableToArray(arr) || FilterDrawer_unsupportedIterableToArray(arr) || FilterDrawer_nonIterableSpread();
}
function FilterDrawer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FilterDrawer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FilterDrawer_arrayLikeToArray(o, minLen);
}
var FILTER_DRAWER_ANCHOR_RIGHT = "vaude" === 'vaude';
var FilterDrawer_mapStateToProps = function(state) {
    return {
        taxons: state.taxons,
        products: state.products,
        parameters: state.parameters,
        attributesSlug: state.taxons.attributesSlug,
        sizesCode: state.taxons.sizesCode,
        attributesLoading: state.taxons.loadingAttribute,
        sizesLoading: state.taxons.loadingSizes
    };
};
var FilterDrawer_mapDispatchToProps = {
    getProductsByTaxonsSlug: products/* getProductsByTaxonsSlug */.R2,
    getTaxonsAttributes: taxons/* getTaxonsAttributes */.xY,
    getTaxonsSizes: taxons/* getTaxonsSizes */.JG,
    setCurrentSlug: products/* setCurrentSlug */.re
};
var FilterDrawer = function(param) {
    var isDrawerOpen = param.isDrawerOpen, setIsDrawerOpen = param.setIsDrawerOpen, getTaxonsAttributes1 = param.getTaxonsAttributes, getTaxonsSizes1 = param.getTaxonsSizes, takebackText = param.takebackText, taxons = param.taxons, parameters = param.parameters, setCurrentSlug1 = param.setCurrentSlug, currentPage = param.currentPage, getProductsByTaxonsSlug1 = param.getProductsByTaxonsSlug, doc = param.doc, t = param.t, attributesSlug = param.attributesSlug, sizesCode = param.sizesCode, attributesLoading = param.attributesLoading, sizesLoading = param.sizesLoading, sort = param.sort, onSortChange = param.onSortChange;
    var ref28, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var classes = (0,FilterDrawer_styles/* useFilterDrawerStyles */.q)();
    var mergeFilterAndSort = doc === null || doc === void 0 ? void 0 : (ref28 = doc.data) === null || ref28 === void 0 ? void 0 : ref28.merge_filter_and_sort;
    var ref19 = (0,react.useState)([]), selectedTaxons = ref19[0], setSelectedTaxons = ref19[1];
    var ref20 = (0,react.useState)([]), activeSlug = ref20[0], setActiveSlug = ref20[1];
    var ref21 = (0,react.useState)(false), open = ref21[0], setOpen = ref21[1];
    var ref22 = (0,react.useState)([]), currentSlide = ref22[0], setCurrentSlide = ref22[1];
    var ref23 = (0,react.useState)(0), currentSlidePosition = ref23[0], setCurrentSlidePosition = ref23[1];
    var ref24 = (0,react.useState)([]), selectedAttributes = ref24[0], setSelectedAttributes = ref24[1];
    var ref25 = (0,react.useState)(!!constants/* isSecondHandOnly */.G7), isSecondHandTaxons = ref25[0], setIsSecondHandTaxons = ref25[1];
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var router = (0,next_router.useRouter)();
    var urlCategories = router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.slug;
    var mainTaxon = taxons === null || taxons === void 0 ? void 0 : (ref2 = taxons.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.children;
    (0,react.useEffect)(function() {
        if (true) {
            setIsSecondHandTaxons(true);
        }
    }, [
        selectedTaxons
    ]);
    // retrieve Filters from URL and get Products
    (0,react.useEffect)(function() {
        var filtersFromUrl = router.query.filters;
        if (filtersFromUrl) {
            try {
                var filtersParsed = JSON.parse(filtersFromUrl);
                if ((filtersParsed === null || filtersParsed === void 0 ? void 0 : filtersParsed.length) > 0) {
                    setSelectedAttributes(filtersParsed);
                }
            } catch (error) {
                console.error('Failed to parse filters from URL:', error);
            }
        }
    }, [
        router.query.filters
    ]);
    (0,react.useEffect)(function() {
        handleStateInit();
    }, [
        taxons === null || taxons === void 0 ? void 0 : taxons.items
    ]);
    var handleStateInit = function() {
        var ref35, ref26, ref27;
        // set selected taxon based on current url
        var mainTaxons = (taxons === null || taxons === void 0 ? void 0 : (ref35 = taxons.items) === null || ref35 === void 0 ? void 0 : (ref26 = ref35[0]) === null || ref26 === void 0 ? void 0 : ref26.children) || [];
        // Filter out excluded taxons if configured
        var excludedSlugs = (doc === null || doc === void 0 ? void 0 : (ref27 = doc.data) === null || ref27 === void 0 ? void 0 : ref27.excluded_taxon_slugs) ? doc.data.excluded_taxon_slugs.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.text;
        }).filter(Boolean) : [];
        if (excludedSlugs.length > 0) {
            mainTaxons = mainTaxons.filter(function(taxon) {
                return !excludedSlugs.includes(taxon.slug);
            });
        }
        var selectedTaxonIndex = 0;
        var selected = [];
        var activeSlugArray = [];
        var isCurrentSLide = [];
        var tempCurrentlocale = 0;
        isCurrentSLide.push(mainTaxons);
        if (typeof urlCategories === 'string') {
            urlCategories = [
                urlCategories
            ];
        }
        // map on the slugs found in url
        urlCategories === null || urlCategories === void 0 ? void 0 : urlCategories.map(function(categorie, index) {
            var ref, ref29, ref30, ref31, ref32;
            // find index of each slugs in url and push it to the selectedTaxons state to pre-select taxons
            selectedTaxonIndex = mainTaxons.findIndex(function(maintaxon) {
                return maintaxon.slug === categorie;
            });
            // add each slug and name in array
            activeSlugArray.push({
                slug: categorie,
                name: (ref = mainTaxons[selectedTaxonIndex]) === null || ref === void 0 ? void 0 : ref.name,
                code: (ref29 = mainTaxons[selectedTaxonIndex]) === null || ref29 === void 0 ? void 0 : ref29.code
            });
            // add current selected Taxon in array
            selected.push({
                pos: index,
                selectedId: selectedTaxonIndex
            });
            // if last url slug has a child, we add the last row with no id selected
            if (index === urlCategories.length - 1 && ((ref30 = mainTaxons[selectedTaxonIndex]) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.children) === null || ref31 === void 0 ? void 0 : ref31.length)) {
                selected.push({
                    pos: index + 1,
                    selectedId: null
                });
            }
            // we update mainTaxon to go to next child and find next slug
            if ((ref32 = mainTaxons[selectedTaxonIndex]) === null || ref32 === void 0 ? void 0 : ref32.children.length) {
                var ref33, ref34;
                tempCurrentlocale = tempCurrentlocale + 1;
                isCurrentSLide.push((ref33 = mainTaxons[selectedTaxonIndex]) === null || ref33 === void 0 ? void 0 : ref33.children);
                mainTaxons = (ref34 = mainTaxons[selectedTaxonIndex]) === null || ref34 === void 0 ? void 0 : ref34.children;
            }
        });
        setCurrentSlidePosition(tempCurrentlocale);
        setCurrentSlide(isCurrentSLide);
        setActiveSlug(activeSlugArray);
        setSelectedTaxons(selected);
    };
    // Function to save or cut the slugs array
    var handleSlug = function(position, taxon) {
        var currentActiveSlug = FilterDrawer_toConsumableArray(activeSlug);
        // if current Active slug exists, we delete it
        if (currentActiveSlug[position]) {
            currentActiveSlug.splice(position);
        }
        currentActiveSlug.push({
            slug: taxon.slug,
            name: taxon.name,
            code: taxon.code
        });
        setActiveSlug(currentActiveSlug);
    };
    //handle slide mode
    var handleNextSlide = function(taxonId, taxon, position) {
        var ref;
        handleSlug(position, taxon);
        var tempSelectedTaxons = FilterDrawer_toConsumableArray(selectedTaxons);
        tempSelectedTaxons[position].selectedId = taxonId;
        if (taxon === null || taxon === void 0 ? void 0 : (ref = taxon.children) === null || ref === void 0 ? void 0 : ref.length) {
            tempSelectedTaxons.push({
                pos: position + 1,
                selectedId: null
            });
        }
        setSelectedTaxons(tempSelectedTaxons);
        var tempArray = FilterDrawer_toConsumableArray(currentSlide);
        if (taxon.children.length > 0) {
            var ref36;
            // Filter out excluded taxons from children
            var excludedSlugs = (doc === null || doc === void 0 ? void 0 : (ref36 = doc.data) === null || ref36 === void 0 ? void 0 : ref36.excluded_taxon_slugs) ? doc.data.excluded_taxon_slugs.map(function(item) {
                return item === null || item === void 0 ? void 0 : item.text;
            }).filter(Boolean) : [];
            var children = taxon.children;
            if (excludedSlugs.length > 0) {
                children = children.filter(function(child) {
                    return !excludedSlugs.includes(child.slug);
                });
            }
            // next taxon has children, change slide and select taxon
            tempArray.splice(position + 1);
            tempArray.push(children);
            setCurrentSlide(tempArray);
            setCurrentSlidePosition(position + 1);
        } else {
            tempArray.splice(position + 1);
            setCurrentSlide(tempArray);
        }
    };
    // get attributes based on last selected taxon slug
    (0,react.useEffect)(function() {
        var currentSlug = activeSlug.length > 0 ? activeSlug[activeSlug.length - 1] : null;
        if (currentSlug) {
            if (!attributesLoading && currentSlug.slug !== attributesSlug) {
                getTaxonsAttributes1(currentSlug === null || currentSlug === void 0 ? void 0 : currentSlug.slug);
            }
            if (!sizesLoading && currentSlug.code !== sizesCode) {
                getTaxonsSizes1(currentSlug === null || currentSlug === void 0 ? void 0 : currentSlug.code);
            }
        }
    }, [
        activeSlug,
        attributesSlug,
        sizesCode,
        attributesLoading,
        sizesLoading
    ]);
    //handle slide mode
    var handlePrevSlide = function() {
        var currentActiveSlug = FilterDrawer_toConsumableArray(activeSlug);
        var tempSelectedTaxons = FilterDrawer_toConsumableArray(selectedTaxons);
        tempSelectedTaxons.splice(currentSlidePosition);
        currentActiveSlug.splice(currentSlidePosition);
        setActiveSlug(currentActiveSlug);
        setSelectedTaxons(tempSelectedTaxons);
        if (currentSlidePosition > 0) {
            setCurrentSlidePosition(currentSlidePosition - 1);
        }
    };
    // handle selection validation and trigger url change
    var handleFilters = function() {
        var asyncFunc = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var fullPathname, cleanAttributes, query;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            fullPathname = '/';
                            activeSlug.map(function(slugs) {
                                fullPathname += "".concat(slugs.slug, "/");
                            });
                            trackEvent({
                                category: 'Shop',
                                action: "User Change category to ".concat(activeSlug[activeSlug.length - 1].name)
                            });
                            cleanAttributes = selectedAttributes.filter(function(attribute) {
                                if ((attribute === null || attribute === void 0 ? void 0 : attribute.values.length) === 0) return false;
                                if (isSecondHandTaxons) {
                                    return attribute.code !== PriceAttributeCode.PRICE;
                                } else {
                                    return ![
                                        'takeBackPrice',
                                        'productCondition'
                                    ].includes(attribute.code);
                                }
                            });
                            query = {
                                slug: activeSlug.map(function(slug) {
                                    return slug.slug;
                                }),
                                filters: JSON.stringify(cleanAttributes)
                            };
                            setCurrentSlug1(activeSlug[activeSlug.length - 1].slug);
                            getProductsByTaxonsSlug1(activeSlug[activeSlug.length - 1].slug, 48, currentPage, cleanAttributes, null, null, isSecondHandTaxons, mergeFilterAndSort ? sort : undefined);
                            _ctx.next = 9;
                            return router.push({
                                pathname: fullPathname,
                                query: query
                            }, undefined, {
                                shallow: true
                            });
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function asyncFunc() {
                return _ref.apply(this, arguments);
            };
        }();
        setIsDrawerOpen(false);
        asyncFunc();
    };
    var handleResetFilters = function() {
        var ref, ref37;
        setActiveSlug([]);
        setSelectedTaxons([]);
        setSelectedAttributes([]);
        setCurrentSlide([
            mainTaxon || []
        ]);
        setCurrentSlidePosition(0);
        localStorage.removeItem('selectedCategory');
        setIsDrawerOpen(false);
        // Root taxon (e.g. "tous-les-produits") holds every product across all
        // categories; its slug varies per client so it can't be hardcoded.
        var rootTaxonSlug = taxons === null || taxons === void 0 ? void 0 : (ref = taxons.items) === null || ref === void 0 ? void 0 : (ref37 = ref[0]) === null || ref37 === void 0 ? void 0 : ref37.slug;
        router.push(rootTaxonSlug ? "/".concat(rootTaxonSlug) : '/shop');
    };
    var handleExtend = function() {
        setOpen(!open);
    };
    // Vaude: l'attribut SELECT « Auswahl » est sorti du dropdown pour être affiché
    // en checkboxes à plat, sous les catégories et au-dessus du premier filtre.
    var flatTopAttribute = (0,react.useMemo)(function() {
        if (constants/* FLAT_TOP_FILTER_ATTRIBUTE_CODES.length */.D$.length === 0) return undefined;
        return ((taxons === null || taxons === void 0 ? void 0 : taxons.attributes) || []).find(function(attr) {
            var ref;
            return (attr === null || attr === void 0 ? void 0 : attr.type) === AttributeType.SELECT && constants/* FLAT_TOP_FILTER_ATTRIBUTE_CODES.includes */.D$.includes(attr === null || attr === void 0 ? void 0 : (ref = attr.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
        });
    }, [
        taxons === null || taxons === void 0 ? void 0 : taxons.attributes
    ]);
    // Attributs restant dans le dropdown (on retire celui affiché à plat)
    var dropdownAttributes = flatTopAttribute ? taxons === null || taxons === void 0 ? void 0 : (ref4 = taxons.attributes) === null || ref4 === void 0 ? void 0 : ref4.filter(function(attr) {
        return attr.code !== flatTopAttribute.code;
    }) : taxons === null || taxons === void 0 ? void 0 : taxons.attributes;
    // Toggle d'une valeur du filtre à plat (même logique que AttributesFilters)
    var handleToggleFlatTopFilter = function(code, key) {
        var tempSelectedAttributes = FilterDrawer_toConsumableArray(selectedAttributes);
        var isCodeSelected = tempSelectedAttributes.find(function(selected) {
            return selected.code === code;
        });
        if (isCodeSelected) {
            var ref;
            var valueIndex = (ref = isCodeSelected.values) === null || ref === void 0 ? void 0 : ref.findIndex(function(value) {
                return value === key;
            });
            if (valueIndex >= 0) {
                isCodeSelected.values.splice(valueIndex, 1);
            } else {
                isCodeSelected.values.push(key);
            }
        } else {
            tempSelectedAttributes.push({
                code: code,
                values: [
                    key
                ]
            });
        }
        setSelectedAttributes(tempSelectedAttributes);
    };
    // @TODO: Move it from here
    var FadeList = function(slides) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.margin,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    component: "div",
                    disablePadding: true,
                    children: slides.slides.length > 0 && (slides === null || slides === void 0 ? void 0 : slides.slides.map(function(taxon, index) {
                        var ref;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_TaxonListItem, {
                                taxon: taxon,
                                handleToggle: handleNextSlide,
                                index: index,
                                name: taxon.name,
                                checked: (ref = selectedTaxons[currentSlidePosition]) === null || ref === void 0 ? void 0 : ref.selectedId,
                                hasCheckbox: false,
                                position: currentSlidePosition,
                                open: false
                            })
                        }, index));
                    }))
                })
            })
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
        anchor: FILTER_DRAWER_ANCHOR_RIGHT ? 'right' : 'left',
        open: isDrawerOpen,
        className: classes.drawer,
        onClose: function() {
            return setIsDrawerOpen(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.drawerContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.header, FILTER_DRAWER_ANCHOR_RIGHT && classes.anchoredRight),
                    children: [
                        currentSlidePosition !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.help,
                            onClick: handlePrevSlide,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                ' ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        defaultText: t('texts:shop:return'),
                                        data: doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.return
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            onClick: function() {
                                return setIsDrawerOpen(false);
                            },
                            size: "small",
                            children: [
                                ' ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    defaultText: t('texts:shop:close_button'),
                                    data: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.close_button
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    disablePadding: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.filterContainer,
                        children: [
                            mergeFilterAndSort && onSortChange && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_FilterDrawerSort, {
                                doc: doc,
                                sort: sort,
                                onSortChange: onSortChange,
                                t: t,
                                classes: {
                                    sortSection: classes.sortSection,
                                    sortTitle: classes.sortTitle
                                }
                            }),
                            mergeFilterAndSort && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.filterTitleSection,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "p",
                                    variant: "body1",
                                    color: "primary",
                                    className: classes.sortTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        defaultText: t('texts:shop:filter_title_in_drawer'),
                                        data: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.filter_title_in_drawer
                                    })
                                })
                            }),
                            currentSlidePosition !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                className: classes.breadcrumb,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: 'span',
                                    variant: 'body1',
                                    color: 'primary',
                                    className: classes.activeFilter,
                                    children: activeSlug.length > 0 ? activeSlug.map(function(slug, key) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: classes.activeFilterText,
                                            children: [
                                                slug.name,
                                                ' ',
                                                activeSlug.length - 1 !== key && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "/\xa0"
                                                })
                                            ]
                                        }, key));
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        defaultText: t('texts:shop:filters_modale_title'),
                                        data: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.filters_modale_title
                                    })
                                })
                            }),
                            ((ref9 = currentSlide[0]) === null || ref9 === void 0 ? void 0 : ref9.length) > 10 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                className: classes.filterListItem,
                                onClick: handleExtend,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body1',
                                        component: 'span',
                                        className: classes.taxonTitle,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            defaultText: t('texts:shop:categories_title'),
                                            data: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.categories_title
                                        })
                                    }),
                                    open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExpandMore/* default */.Z, {})
                                ]
                            }),
                            ((ref11 = currentSlide[0]) === null || ref11 === void 0 ? void 0 : ref11.length) > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                in: open,
                                timeout: "auto",
                                unmountOnExit: true,
                                children: currentSlide.map(function(slides, index) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                        //direction="left"
                                        in: currentSlidePosition === index,
                                        unmountOnExit: true,
                                        timeout: {
                                            appear: 800,
                                            enter: 800,
                                            exit: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeList, {
                                            slides: slides
                                        })
                                    }, index));
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: currentSlide.map(function(slides, index) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                        //direction="left"
                                        in: currentSlidePosition === index,
                                        unmountOnExit: true,
                                        timeout: {
                                            appear: 800,
                                            enter: 800,
                                            exit: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeList, {
                                            slides: slides
                                        })
                                    }, index));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.filterContainer,
                                children: [
                                    ((taxons === null || taxons === void 0 ? void 0 : (ref12 = taxons.sizes) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 && !constants/* disableSecondHandSizeAndCondition */.wK || (taxons === null || taxons === void 0 ? void 0 : (ref13 = taxons.attributes) === null || ref13 === void 0 ? void 0 : ref13.length) > 0) && !mergeFilterAndSort && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: classes.filterBy_text,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            defaultText: t('texts:shop:filter_by'),
                                            data: doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.filter_by
                                        })
                                    }),
                                    attributesLoading || sizesLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.loaderContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            flatTopAttribute && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                                component: "div",
                                                disablePadding: true,
                                                children: (ref15 = flatTopAttribute.choices) === null || ref15 === void 0 ? void 0 : ref15.map(function(choice, index) {
                                                    var ref, ref38;
                                                    var isChecked = (ref = selectedAttributes.find(function(selected) {
                                                        return selected.code === flatTopAttribute.code;
                                                    })) === null || ref === void 0 ? void 0 : (ref38 = ref.values) === null || ref38 === void 0 ? void 0 : ref38.includes(choice.key);
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_AttributeListItem, {
                                                        code: flatTopAttribute.code,
                                                        attributeKey: choice.key,
                                                        handleToggle: handleToggleFlatTopFilter,
                                                        index: index,
                                                        name: choice.value,
                                                        checked: !!isChecked
                                                    }, choice.key));
                                                })
                                            }),
                                            (taxons === null || taxons === void 0 ? void 0 : (ref16 = taxons.sizes) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && !constants/* disableSecondHandSizeAndCondition */.wK && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_SizesFilters, {
                                                sizes: taxons === null || taxons === void 0 ? void 0 : taxons.sizes,
                                                setSelectedAttributes: setSelectedAttributes,
                                                selectedAttributes: selectedAttributes
                                            }),
                                            (dropdownAttributes === null || dropdownAttributes === void 0 ? void 0 : dropdownAttributes.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_AttributesFilters, {
                                                parameters: parameters,
                                                takebackText: takebackText,
                                                attributes: dropdownAttributes,
                                                setSelectedAttributes: setSelectedAttributes,
                                                selectedAttributes: selectedAttributes,
                                                t: t,
                                                doc: doc,
                                                isSecondHandTaxons: isSecondHandTaxons
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.footer, FILTER_DRAWER_ANCHOR_RIGHT && classes.anchoredRight),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function() {
                                return handleResetFilters();
                            },
                            variant: 'text',
                            className: classes.resetButton,
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Replay/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        defaultText: t('texts:shop:reset_button'),
                                        data: doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : ref17.reset_button
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function() {
                                return handleFilters();
                            },
                            variant: 'contained',
                            color: 'primary',
                            className: "".concat(classes.applyButton, " filters-drawer__apply"),
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                defaultText: t('texts:shop:apply_button'),
                                data: doc === null || doc === void 0 ? void 0 : (ref18 = doc.data) === null || ref18 === void 0 ? void 0 : ref18.apply_button
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Filters_FilterDrawer = ((0,es/* connect */.$j)(FilterDrawer_mapStateToProps, FilterDrawer_mapDispatchToProps)(FilterDrawer));

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
// EXTERNAL MODULE: ./components/HrefLangLinks.tsx
var HrefLangLinks = __webpack_require__(39998);
;// CONCATENATED MODULE: ./redux/actions/shop.ts
var SAVE_SHOP_STATE = function(state) {
    return {
        type: 'SAVE_SHOP_STATE',
        payload: state
    };
};
var RESTORE_SHOP_STATE = function() {
    return {
        type: 'RESTORE_SHOP_STATE'
    };
};

;// CONCATENATED MODULE: ./pages/[...slug].tsx



























function _slug_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _slug_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _slug_arrayLikeToArray(arr);
}
function _slug_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _slug_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slug_toConsumableArray(arr) {
    return _slug_arrayWithoutHoles(arr) || _slug_iterableToArray(arr) || _slug_unsupportedIterableToArray(arr) || _slug_nonIterableSpread();
}
function _slug_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _slug_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _slug_arrayLikeToArray(o, minLen);
}
var STATE_PERSISTENCE_DURATION = 15 * 60 * 1000 // 15 minutes in milliseconds
;
var _slug_mapStateToProps = function(state) {
    return {
        taxons: state.taxons,
        cart: state.cart,
        products: state.products,
        stock: state.stock,
        parameters: state.parameters,
        shopPage: state.shopPage
    };
};
var _slug_mapDispatchToProps = {
    getTaxons: taxons/* getTaxons */.xI,
    getProductsByTaxonsSlug: products/* getProductsByTaxonsSlug */.R2,
    getCumulativeProductsByTaxonsSlug: products/* getCumulativeProductsByTaxonsSlug */.Or,
    setCurrentSlug: products/* setCurrentSlug */.re,
    emptyProductState: products/* emptyProductState */.XD
};
var Shop = function(param) {
    var getTaxons1 = param.getTaxons, taxons = param.taxons, doc = param.doc, basket = param.basket, takeback = param.takeback, inStoreText = param.inStoreText, main = param.main, funnel = param.funnel, classic_sub = param.classic_sub, emptyProductState1 = param.emptyProductState, getProductsByTaxonsSlug1 = param.getProductsByTaxonsSlug, getCumulativeProductsByTaxonsSlug1 = param.getCumulativeProductsByTaxonsSlug, cart = param.cart, stock = param.stock, parameters = param.parameters, setCurrentSlug1 = param.setCurrentSlug, pageData = param.pageData, productSettings = param.productSettings, products = param.products, accountRes = param.accountRes, faqRes = param.faqRes, banner = param.banner, shopPage = param.shopPage;
    var ref57, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48;
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var ref49;
    var currentLocale = (ref49 = router === null || router === void 0 ? void 0 : router.locale) !== null && ref49 !== void 0 ? ref49 : 'fr';
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('xs'));
    var category = router === null || router === void 0 ? void 0 : (ref57 = router.query) === null || ref57 === void 0 ? void 0 : ref57.slug;
    var LayoutStyle = {
        isZwiterHandCategory: (category === null || category === void 0 ? void 0 : category.length) && constants/* SECOND_HAND_TAXON_SLUGS.includes */.$X.includes(category[0])
    };
    var classes = (0,Shop_style/* default */.Z)(LayoutStyle);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref50 = (0,useMatomo/* default */.Z)(), trackPageView = ref50.trackPageView, trackEvent = ref50.trackEvent;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref51 = (0,react.useState)(false), isDrawerOpen = ref51[0], setIsDrawerOpen = ref51[1];
    var ref52 = (0,react.useState)(true), isLoadingProductsAndStocks = ref52[0], setIsLoadingProductsAndStocks = ref52[1];
    var ref53 = (0,react.useState)(true), fetchingTaxons = ref53[0], setFetchingTaxons = ref53[1];
    var currentPageFromQuery = router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.currentPage;
    var page = Array.isArray(currentPageFromQuery) ? currentPageFromQuery[0] : currentPageFromQuery || '1';
    var ref54 = (0,react.useState)(0), selectedCategory = ref54[0], setSelectedCategories = ref54[1];
    var ref55 = (0,react.useState)(typeof page !== 'undefined' ? parseInt(page) : 1), currentPage = ref55[0], setCurrentPage = ref55[1];
    var defaultSortValue = (0,useShopSorting/* useShopSorting */.P)(doc).defaultSortValue;
    var ref56 = (0,react.useState)(defaultSortValue || null), sort1 = ref56[0], setSort = ref56[1];
    // Update sort if defaultSortValue changes and sort is not set
    (0,react.useEffect)(function() {
        if (!sort1 && defaultSortValue) {
            setSort(defaultSortValue);
        }
    }, [
        defaultSortValue,
        sort1
    ]);
    var columnLayout = main === null || main === void 0 ? void 0 : (ref2 = main.data) === null || ref2 === void 0 ? void 0 : ref2.page_shop_layout;
    var settings = main === null || main === void 0 ? void 0 : main.data;
    var isMobileAccordion = doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.is_display_accordion_on_mobile_page;
    var isRawFormattedText = doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.raw_formatted_shop_description;
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref5 = parameters.items) === null || ref5 === void 0 ? void 0 : ref5.enableChooseStartingDate;
    var loadMore = doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.pagination_mode;
    var productToLoadLimit = (doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.product_limit_per_load) !== null ? doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.product_limit_per_load : 48;
    var hrefLangs = (0,react.useMemo)(function() {
        var ref;
        var hrefLanguages = main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.href_languages;
        if (hrefLanguages) {
            var text = (0,CMSText/* prismicText */.yz)(hrefLanguages);
            return text ? text.split(',') : [];
        }
        return [];
    }, [
        main
    ]);
    var isSecondHandTaxon = constants/* isSecondHandOnly */.G7 === 'true' ? true : constants/* SECOND_HAND_TAXON_SLUGS.includes */.$X.includes(category === null || category === void 0 ? void 0 : category[0]);
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            funnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
            basket: basket === null || basket === void 0 ? void 0 : basket.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data,
            account: accountRes === null || accountRes === void 0 ? void 0 : accountRes.data
        }));
    }, [
        funnel,
        main,
        basket,
        inStoreText,
        accountRes
    ]);
    (0,react.useEffect)(function() {
        trackPageView({
            documentTitle: 'Shop'
        });
        if (settings === null || settings === void 0 ? void 0 : settings.only_add_with_pack) {
            router.push('packs');
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref58;
        // Don't fetch taxons if we have saved state
        if (shopPage === null || shopPage === void 0 ? void 0 : (ref = shopPage.savedState) === null || ref === void 0 ? void 0 : (ref58 = ref.products) === null || ref58 === void 0 ? void 0 : ref58.length) {
            setFetchingTaxons(false);
            return;
        }
        getTaxons1();
        setFetchingTaxons(true);
    }, [
        currentLocale
    ]);
    (0,react.useEffect)(function() {
        if (taxons.loading === false) {
            setFetchingTaxons(false);
        }
    }, [
        taxons.loading
    ]);
    (0,react.useEffect)(function() {
        if (!fetchingTaxons && (taxons === null || taxons === void 0 ? void 0 : taxons.items) && (taxons === null || taxons === void 0 ? void 0 : taxons.items.length)) {
            if (category[0] === 'shop') {
                Array.isArray(category) && category.shift();
                router.push(Array.isArray(category) && category.join('/'));
            }
            var slugs = Array.isArray(category) ? _slug_toConsumableArray(category) : [
                category
            ];
            if (!(0,utils/* findIfSlugExist */.Lx)(taxons === null || taxons === void 0 ? void 0 : taxons.items[0], slugs)) {
                router.push('404');
            }
        }
    }, [
        taxons.items
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((taxons === null || taxons === void 0 ? void 0 : (ref = taxons.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref59, ref60;
            setSelectedCategories((ref59 = taxons === null || taxons === void 0 ? void 0 : taxons.items[0]) === null || ref59 === void 0 ? void 0 : (ref60 = ref59.children) === null || ref60 === void 0 ? void 0 : ref60.findIndex(function(taxon) {
                return (taxon === null || taxon === void 0 ? void 0 : taxon.slug) === category[0];
            }));
        }
    }, [
        taxons === null || taxons === void 0 ? void 0 : taxons.items
    ]);
    (0,react.useEffect)(function() {
        if ((category === null || category === void 0 ? void 0 : category.length) > 0) {
            if (typeof category === 'string') {
                category = [
                    category
                ];
            }
            if (products.currentSlug !== category[category.length - 1]) {
                emptyProductState1();
            }
            var filtersFromUrl = router.query.filters;
            if (loadMore) {
                var ref, ref61;
                if ((products === null || products === void 0 ? void 0 : (ref = products.items) === null || ref === void 0 ? void 0 : (ref61 = ref.items) === null || ref61 === void 0 ? void 0 : ref61.length) === 0) {
                    setCurrentSlug1(category[category.length - 1]);
                    getCumulativeProductsByTaxonsSlug1(category[category.length - 1], productToLoadLimit, currentPage, filtersFromUrl ? JSON.parse(filtersFromUrl) : [], null, null, isSecondHandTaxon, sort1);
                }
            } else {
                setCurrentSlug1(category[category.length - 1]);
                getProductsByTaxonsSlug1(category[category.length - 1], 48, currentPage, filtersFromUrl ? JSON.parse(filtersFromUrl) : [], null, null, isSecondHandTaxon, sort1);
            }
        }
    }, [
        products === null || products === void 0 ? void 0 : (ref9 = products.items) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.items) === null || ref10 === void 0 ? void 0 : ref10.length
    ]);
    (0,react.useEffect)(function() {
        selectedCategory !== -1 && localStorage.setItem('selectedCategory', selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.toString());
    }, [
        selectedCategory
    ]);
    var heroInfo = (0,react.useMemo)(function() {
        var ref, ref62, ref63, ref64;
        // Parse data from the received page data (if there's a page with the current slug)
        return {
            title: (0,CMSText/* prismicText */.yz)(pageData === null || pageData === void 0 ? void 0 : pageData.data.title).toUpperCase(),
            // Check if a hero section has been added to the page, and get its background image
            image: (ref63 = pageData === null || pageData === void 0 ? void 0 : (ref = pageData.data) === null || ref === void 0 ? void 0 : (ref62 = ref.body) === null || ref62 === void 0 ? void 0 : ref62.find(function(el) {
                return el.slice_type === 'hero_section';
            })) === null || ref63 === void 0 ? void 0 : (ref64 = ref63.primary) === null || ref64 === void 0 ? void 0 : ref64.background
        };
    }, [
        pageData === null || pageData === void 0 ? void 0 : pageData.data
    ]);
    var handlePrev = (0,react.useCallback)(function() {
        setCurrentPage(currentPage - 1);
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
        var pageNumber = currentPage - 1;
        if ((category === null || category === void 0 ? void 0 : category.length) > 0) {
            if (typeof category === 'string') {
                category = [
                    category
                ];
            } else {
                category = [
                    category.join('/')
                ];
            }
        }
        router.push({
            pathname: '/' + category,
            query: {
                currentPage: pageNumber
            }
        }, undefined, {
            shallow: true
        });
    }, [
        currentPage,
        category,
        page
    ]);
    var handleNext = (0,react.useCallback)(function() {
        setCurrentPage(currentPage + 1);
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
        var pageNumber = currentPage + 1;
        if ((category === null || category === void 0 ? void 0 : category.length) > 0) {
            if (typeof category === 'string') {
                category = [
                    category
                ];
            } else {
                category = [
                    category.join('/')
                ];
            }
        }
        router.push({
            pathname: '/' + category,
            query: {
                currentPage: pageNumber
            }
        }, undefined, {
            shallow: true
        });
    }, [
        currentPage,
        category,
        page
    ]);
    var handleSort = (0,react.useCallback)(function(sort) {
        setSort(sort);
        setCurrentPage(1);
    }, [
        setSort,
        setCurrentPage
    ]);
    var handleSortChange = (0,react.useCallback)(function(sortValue) {
        if (!sortValue) return;
        handleSort(sortValue);
        var slug = router.query.slug;
        trackEvent({
            category: 'Shop',
            action: "User sorting by ".concat(Object.keys(sortValue)[0], ":").concat(sortValue[Object.keys(sortValue)[0]], " in ").concat(slug)
        });
        if ((category === null || category === void 0 ? void 0 : category.length) > 0) {
            var categorySlug = Array.isArray(category) ? category[category.length - 1] : category;
            var filtersFromUrl = router.query.filters;
            getProductsByTaxonsSlug1(categorySlug, 48, 1, filtersFromUrl ? JSON.parse(filtersFromUrl) : [], null, null, isSecondHandTaxon, sortValue);
        }
    }, [
        handleSort,
        router.query,
        category,
        getProductsByTaxonsSlug1,
        isSecondHandTaxon,
        trackEvent, 
    ]);
    var handleLoadMore = (0,react.useCallback)(function() {
        var pageNumber = currentPage + 1;
        setCurrentPage(pageNumber);
        if ((category === null || category === void 0 ? void 0 : category.length) > 0) {
            if (typeof category === 'string') {
                category = [
                    category
                ];
            }
            var filtersFromUrl = router.query.filters;
            getCumulativeProductsByTaxonsSlug1(category[category.length - 1], productToLoadLimit, pageNumber, filtersFromUrl ? JSON.parse(filtersFromUrl) : [], null, currentLocale, isSecondHandTaxon, sort1);
        }
    }, [
        currentPage,
        category,
        sort1
    ]);
    (0,react.useEffect)(function() {
        if (!taxons.loading && !products.loading && !stock.loading || stock.loading && products.isCumulative) {
            if (isLoadingProductsAndStocks) {
                setIsLoadingProductsAndStocks(false);
            }
        } else {
            var ref, ref65;
            // Don't set loading state if we have saved products
            if (!(shopPage === null || shopPage === void 0 ? void 0 : (ref = shopPage.savedState) === null || ref === void 0 ? void 0 : (ref65 = ref.products) === null || ref65 === void 0 ? void 0 : ref65.length)) {
                if (!isLoadingProductsAndStocks) {
                    setIsLoadingProductsAndStocks(true);
                }
            }
        }
    }, [
        taxons.loading,
        products.loading,
        products.isCumulative,
        stock.loading
    ]);
    var ClaimTexts = (0,react.useCallback)(function() {
        var ref, ref66, ref67, ref68, ref69, ref70, ref71, ref72;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            spacing: isMobile ? 3 : 9,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (0,CMSText/* isPrismicText */.LT)(doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.titleshop) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "p",
                                variant: "h3",
                                className: "shop-claim__title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: !isRawFormattedText,
                                    data: doc === null || doc === void 0 ? void 0 : (ref66 = doc.data) === null || ref66 === void 0 ? void 0 : ref66.titleshop,
                                    defaultText: t('texts:shop:titleshop')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: !isRawFormattedText ? 'p' : 'div',
                                variant: "body1",
                                className: "shop-claim__desc",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: !isRawFormattedText,
                                    data: doc === null || doc === void 0 ? void 0 : (ref67 = doc.data) === null || ref67 === void 0 ? void 0 : ref67.shopdescription,
                                    defaultText: t('texts:shop:shopdescription')
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Commitment/* default */.Z, {
                        desc: (doc === null || doc === void 0 ? void 0 : (ref68 = doc.data) === null || ref68 === void 0 ? void 0 : ref68.shippingdescription) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc.data.shippingdescription
                        }) : t('texts:shop:shippingdescription'),
                        icon: (doc === null || doc === void 0 ? void 0 : (ref69 = doc.data) === null || ref69 === void 0 ? void 0 : (ref70 = ref69.shippingimage) === null || ref70 === void 0 ? void 0 : ref70.url) ? doc === null || doc === void 0 ? void 0 : (ref71 = doc.data) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.shippingimage) === null || ref72 === void 0 ? void 0 : ref72.url : null
                    })
                })
            ]
        });
    }, [
        doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.titleshop,
        doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.shopdescription,
        doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : ref13.shippingdescription,
        doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.shippingimage,
        isRawFormattedText,
        t, 
    ]);
    var heroSectionTitle = (0,react.useMemo)(function() {
        var ref, ref73, ref74;
        if ((doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.use_taxon_title) && (taxons === null || taxons === void 0 ? void 0 : (ref73 = taxons.items) === null || ref73 === void 0 ? void 0 : ref73.length) != 0 && category.length != 0) {
            var ref75;
            var findTaxonBySlug = function() {
                var taxonItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], slug = arguments.length > 1 ? arguments[1] : void 0;
                return taxonItems.find(function(taxon) {
                    return taxon.slug === slug;
                });
            };
            var currentTaxon = taxons === null || taxons === void 0 ? void 0 : taxons.items[0];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = category[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var categorySlug = _step.value;
                    var childTaxon = findTaxonBySlug(currentTaxon === null || currentTaxon === void 0 ? void 0 : currentTaxon.children, categorySlug);
                    if (!childTaxon) break;
                    currentTaxon = childTaxon;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return currentTaxon === null || currentTaxon === void 0 ? void 0 : (ref75 = currentTaxon.name) === null || ref75 === void 0 ? void 0 : ref75.toUpperCase();
        }
        if (heroInfo.title) return heroInfo.title;
        return (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref74 = doc.data) === null || ref74 === void 0 ? void 0 : ref74.herotitle);
    }, [
        heroInfo,
        doc,
        taxons,
        category
    ]);
    // Save state when leaving page
    (0,react.useEffect)(function() {
        return function() {
            var ref;
            dispatch(SAVE_SHOP_STATE({
                currentPage: currentPage,
                selectedCategory: selectedCategory,
                sort: sort1,
                products: (ref = products.items) === null || ref === void 0 ? void 0 : ref.items,
                scrollPosition: window.scrollY,
                isDrawerOpen: isDrawerOpen,
                currentQuery: router.query,
                currentPath: router.asPath,
                timestamp: Date.now()
            }));
        };
    }, [
        currentPage,
        selectedCategory,
        sort1,
        products.items,
        isDrawerOpen,
        router, 
    ]);
    // Restore state when returning
    (0,react.useEffect)(function() {
        if (shopPage === null || shopPage === void 0 ? void 0 : shopPage.savedState) {
            var isRecentNavigation = Date.now() - shopPage.savedState.timestamp < STATE_PERSISTENCE_DURATION;
            var isSameCategory = shopPage.savedState.currentPath.split('/').pop() === router.asPath.split('/').pop();
            if (!isSameCategory) {
                dispatch(RESTORE_SHOP_STATE());
                return;
            }
            setCurrentPage(shopPage.savedState.currentPage);
            setSelectedCategories(shopPage.savedState.selectedCategory);
            setSort(shopPage.savedState.sort);
            setIsDrawerOpen(shopPage.savedState.isDrawerOpen);
            setIsLoadingProductsAndStocks(false);
            // Only restore scroll for recent SPA navigation within same category
            if (isRecentNavigation && isSameCategory) {
                requestAnimationFrame(function() {
                    window.scrollTo(0, shopPage.savedState.scrollPosition);
                });
            }
            dispatch(RESTORE_SHOP_STATE());
        }
    }, []) // Remove dependency array to run only once on mount
    ;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            mainLogo: main === null || main === void 0 ? void 0 : (ref15 = main.data) === null || ref15 === void 0 ? void 0 : ref15.logo,
            doc: main,
            t: t,
            inStoreText: inStoreText,
            metaTitle: (taxons === null || taxons === void 0 ? void 0 : (ref16 = taxons.items) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && (taxons === null || taxons === void 0 ? void 0 : (ref17 = taxons.items) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[0]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.children) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[selectedCategory]) === null || ref20 === void 0 ? void 0 : ref20.name) || (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref21 = doc.data) === null || ref21 === void 0 ? void 0 : ref21.meta_title_shop),
            metaDescription: (taxons === null || taxons === void 0 ? void 0 : (ref22 = taxons.items) === null || ref22 === void 0 ? void 0 : ref22.length) > 0 && ((ref23 = taxons === null || taxons === void 0 ? void 0 : taxons.items[0].children[selectedCategory]) === null || ref23 === void 0 ? void 0 : ref23.description) || (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref24 = doc.data) === null || ref24 === void 0 ? void 0 : ref24.meta_description_shop),
            metaImage: (taxons === null || taxons === void 0 ? void 0 : (ref25 = taxons.items) === null || ref25 === void 0 ? void 0 : (ref26 = ref25[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.children) === null || ref27 === void 0 ? void 0 : (ref28 = ref27[selectedCategory]) === null || ref28 === void 0 ? void 0 : ref28.images.length) ? taxons === null || taxons === void 0 ? void 0 : (ref29 = taxons.items) === null || ref29 === void 0 ? void 0 : (ref30 = ref29[0]) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.children) === null || ref31 === void 0 ? void 0 : (ref32 = ref31[selectedCategory]) === null || ref32 === void 0 ? void 0 : ref32.images[0].cachedPath : undefined,
            metaKeywords: doc === null || doc === void 0 ? void 0 : (ref33 = doc.data) === null || ref33 === void 0 ? void 0 : ref33.meta_keywords_shop,
            basket: basket,
            takeback: takeback,
            account: accountRes,
            faq: faqRes,
            banner: banner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangLinks/* default */.Z, {
                    locales: hrefLangs
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    className: "main main--shop ".concat(classes.root),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {
                            title: heroSectionTitle,
                            isMainTitle: true,
                            topTitle: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref34 = doc.data) === null || ref34 === void 0 ? void 0 : ref34.hero_top_title),
                            heroImg: heroInfo.image || (main === null || main === void 0 ? void 0 : (ref35 = main.data) === null || ref35 === void 0 ? void 0 : ref35.hero_banner),
                            heroSettings: main === null || main === void 0 ? void 0 : main.data,
                            taxonImg: (doc === null || doc === void 0 ? void 0 : (ref36 = doc.data) === null || ref36 === void 0 ? void 0 : ref36.use_taxon_image) && (taxons === null || taxons === void 0 ? void 0 : (ref37 = taxons.items) === null || ref37 === void 0 ? void 0 : ref37.length) > 0 && ((ref38 = taxons === null || taxons === void 0 ? void 0 : taxons.items[0]) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.children) === null || ref39 === void 0 ? void 0 : (ref40 = ref39[selectedCategory]) === null || ref40 === void 0 ? void 0 : ref40.images[0]),
                            isDisplayAccordionOnMobile: isMobileAccordion
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: (0,clsx_m/* default */.Z)('shop__content', classes.shopContent),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                    maxWidth: "xl",
                                    className: classes.shopContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)('shop__planner', classes.shopPlanner, !isSubscription && classes.shopPlannerDad, isSubscription && classes.noBoxShadow, isSubscription && columnLayout && classes.shopPlannerColumn, isSubscription && isMobile && isMobileAccordion && classes.shopPlannerMobileAccordion, isSecondHandTaxon && classes.hideDatePicker),
                                            children: !isSubscription || isEnableChooseStartingDate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeForm/* default */.Z, {
                                                isLanding: false,
                                                t: t,
                                                text: main === null || main === void 0 ? void 0 : main.data,
                                                textFunnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
                                                parameters: parameters,
                                                scrollTarget: 'catalog'
                                            }) : !columnLayout && (doc === null || doc === void 0 ? void 0 : (ref41 = doc.data) === null || ref41 === void 0 ? void 0 : ref41.has_shipping_card) && (isMobile && isMobileAccordion ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.shopIntroMobileAccordion,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                                            expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                                                            "aria-controls": "panel1a-content",
                                                            id: "panel1a-header",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                component: 'p',
                                                                variant: "body1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : (ref42 = doc.data) === null || ref42 === void 0 ? void 0 : ref42.accordion_shop_title,
                                                                    defaultText: t('texts:shop:accordion_shop_title')
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimTexts, {})
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimTexts, {}))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                            maxWidth: "xl",
                                            className: (0,clsx_m/* default */.Z)('shop__area', classes.shopArea, isSubscription && columnLayout && classes.shopAreaColumn),
                                            "data-stock": stock.loading ? 'loading' : 'loaded',
                                            children: [
                                                cart.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.loader,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                                }),
                                                !isSubscription && !columnLayout && (doc === null || doc === void 0 ? void 0 : (ref43 = doc.data) === null || ref43 === void 0 ? void 0 : ref43.has_shipping_card) && !constants/* SECOND_HAND_TAXON_SLUGS.includes */.$X.includes(category[0]) && (isMobile && isMobileAccordion ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx_m/* default */.Z)(classes.shopIntroMobileAccordion, 'shop__intro--mobile__accordion'),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                                                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                                                                "aria-controls": "panel1a-content",
                                                                id: "panel1a-header",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    component: 'p',
                                                                    variant: "body1",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                        asText: true,
                                                                        data: doc === null || doc === void 0 ? void 0 : (ref44 = doc.data) === null || ref44 === void 0 ? void 0 : ref44.accordion_shop_title,
                                                                        defaultText: t('texts:shop:accordion_shop_title')
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimTexts, {})
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.shopIntro,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimTexts, {})
                                                })),
                                                typeof taxons.items !== 'undefined' && taxons.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        isLoadingProductsAndStocks && currentPage === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                                            in: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classes.loader,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Catalog/* default */.Z, {
                                                            taxons: taxons,
                                                            products: products,
                                                            loadMore: loadMore,
                                                            handleLoadMore: handleLoadMore,
                                                            setIsDrawerOpen: setIsDrawerOpen,
                                                            currentPage: currentPage,
                                                            handlePrev: handlePrev,
                                                            handleNext: handleNext,
                                                            handleSort: handleSort,
                                                            classic_sub_text: classic_sub,
                                                            shopData: doc,
                                                            isPack: (main === null || main === void 0 ? void 0 : (ref45 = main.data) === null || ref45 === void 0 ? void 0 : ref45.pack_page) ? main === null || main === void 0 ? void 0 : (ref46 = main.data) === null || ref46 === void 0 ? void 0 : ref46.pack_page : false,
                                                            settings: settings,
                                                            hidePrice: settings === null || settings === void 0 ? void 0 : settings.only_add_with_pack,
                                                            productSettings: productSettings,
                                                            basket: basket,
                                                            cart: cart,
                                                            takeback: takeback,
                                                            isDisplayedPrice: main === null || main === void 0 ? void 0 : (ref47 = main.data) === null || ref47 === void 0 ? void 0 : ref47.is_product_price_displayed,
                                                            isLoadingProductsAndStocks: isLoadingProductsAndStocks,
                                                            mainData: main,
                                                            sort: sort1
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (taxons === null || taxons === void 0 ? void 0 : (ref48 = taxons.items) === null || ref48 === void 0 ? void 0 : ref48.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_FilterDrawer, {
                                    setIsDrawerOpen: setIsDrawerOpen,
                                    isDrawerOpen: isDrawerOpen,
                                    doc: doc,
                                    t: t,
                                    currentPage: currentPage,
                                    takebackText: takeback,
                                    sort: sort1,
                                    onSortChange: handleSortChange
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = ((0,es/* connect */.$j)(_slug_mapStateToProps, _slug_mapDispatchToProps)(Shop));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,76142,75436,84997,16689,230,19789,29705,79956,17012,18496,4998,59134,54972,49774,92888,40179], function() { return __webpack_exec__(73405); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);